import { useState } from "react";
import { BASE_URL } from "../constants";
import { Modal, Input, Select, Textarea, Btn } from "./UI";

export default function CreateJobModal({ token, onClose, onSuccess }) {
  const [form, setForm] = useState({
    title: "", company: "", description: "", requirements: "",
    jobType: "Full Time", industry: "IT & Technology", category: "Sales",
    city: "", state: "Uttar Pradesh", isRemote: false,
    salaryMin: "", salaryMax: "", salaryPeriod: "Monthly", isSalaryShown: true,
    experienceLevel: "Fresher", minEducation: "Graduate", totalOpenings: 1,
    skillsRequired: "", applicationDeadline: "2027-04-30",
    contactEmail: "", contactPhone: "",
  });
  const [loading, setLoading] = useState(false);

  const f = (k) => (e) => setForm(p => ({ ...p, [k]: e.target.value }));

  const submit = async () => {
    if (!form.title || !form.company || !form.description) {
      alert("Please fill in Title, Company, and Description.");
      return;
    }
    setLoading(true);
    try {
      const body = {
        ...form,
        salaryMin:      +form.salaryMin,
        salaryMax:      +form.salaryMax,
        totalOpenings:  +form.totalOpenings,
        skillsRequired: form.skillsRequired.split(",").map(s => s.trim()).filter(Boolean),
      };
      const res  = await fetch(`${BASE_URL}/agent/job/create`, {
        method:  "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body:    JSON.stringify(body),
      });
      const data = await res.json();
      if (data.success) onSuccess("Job created! Pending admin approval.");
      else onSuccess(data.message || "Failed to create job", "error");
    } catch {
      onSuccess("Network error. Please try again.", "error");
    }
    setLoading(false);
  };

  return (
    <Modal title="Post New Job" onClose={onClose}>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 }}>
        <Input label="Job Title *"  value={form.title}   onChange={f("title")}   placeholder="e.g. Flutter Developer" />
        <Input label="Company *"    value={form.company} onChange={f("company")} placeholder="Company name" />
      </div>

      <Textarea label="Description *"  value={form.description}  onChange={f("description")}  placeholder="Describe the role…" />
      <Textarea label="Requirements"   value={form.requirements} onChange={f("requirements")} placeholder="Skills & experience required…" />

      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 }}>
        <Select label="Job Type" value={form.jobType} onChange={f("jobType")}>
          {["Full Time", "Part Time", "Internship", "Contract"].map(t => <option key={t}>{t}</option>)}
        </Select>
        <Select label="Industry" value={form.industry} onChange={f("industry")}>
          {["IT & Technology", "Real Estate", "Healthcare", "Finance", "Education", "Hospitality", "Other"].map(t => <option key={t}>{t}</option>)}
        </Select>
        <Select label="Experience Level" value={form.experienceLevel} onChange={f("experienceLevel")}>
          {["Fresher", "1-2 years", "2-5 years", "5+ years"].map(t => <option key={t}>{t}</option>)}
        </Select>
        <Select label="Salary Period" value={form.salaryPeriod} onChange={f("salaryPeriod")}>
          {["Monthly", "Yearly", "Hourly"].map(t => <option key={t}>{t}</option>)}
        </Select>
        <Input label="City"           value={form.city}       onChange={f("city")}       placeholder="Noida" />
        <Input label="State"          value={form.state}      onChange={f("state")}      placeholder="Uttar Pradesh" />
        <Input label="Min Salary (₹)" type="number" value={form.salaryMin} onChange={f("salaryMin")} placeholder="10000" />
        <Input label="Max Salary (₹)" type="number" value={form.salaryMax} onChange={f("salaryMax")} placeholder="20000" />
        <Input label="Total Openings" type="number" value={form.totalOpenings} onChange={f("totalOpenings")} />
        <Input label="Min Education"  value={form.minEducation} onChange={f("minEducation")} placeholder="Graduate" />
        <Input label="Contact Email"  value={form.contactEmail} onChange={f("contactEmail")} type="email" />
        <Input label="Contact Phone"  value={form.contactPhone} onChange={f("contactPhone")} type="tel" />
      </div>

      <Input
        label="Skills Required (comma separated)"
        value={form.skillsRequired}
        onChange={f("skillsRequired")}
        placeholder="Flutter, Dart, API Integration"
      />
      <Input label="Application Deadline" type="date" value={form.applicationDeadline} onChange={f("applicationDeadline")} />

      <div style={{ display: "flex", gap: 10, justifyContent: "flex-end", marginTop: 8 }}>
        <Btn variant="secondary" onClick={onClose}>Cancel</Btn>
        <Btn onClick={submit} disabled={loading}>{loading ? "Posting…" : "Post Job"}</Btn>
      </div>
    </Modal>
  );
}